module.exports = __webpack_public_path__ + "static/media/p2_12.3c111753.png";